import { render } from "./ProjectSingleRelatedProjects.vue?vue&type=template&id=d4bcb22e"
import script from "./ProjectSingleRelatedProjects.vue?vue&type=script&lang=js"
export * from "./ProjectSingleRelatedProjects.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__